import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const TestNaturalPerson = () => {
  return (
    <Flow>
      <Flow.Progress label='Verificação de identidade' />

      <Flow.StepList>
        <Step name='phone-natural' />
        <Step name='bank-account' />
        <Step name='address' />
        <Step name='occupation-natural' />
        <Step name='income-natural' />
        <Step name='pep-natural' />
        <Step name='terms' />
      </Flow.StepList>
    </Flow>
  );
};
